module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-449df6858d07caccb068d8d0454905a4.png";